// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import BaiduMap from 'vue-baidu-map'
import axios from 'axios'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import "swiper/css/swiper.min.css";
import './assets/font/font.css';

Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false
Vue.use(BaiduMap, {
  ak: 'RSvsIUUQZUCSCzBMGauguyiwYFwKeHkp'
})
Vue.prototype.$axios  = axios;
Vue.prototype.$host = ''
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

import './common/rem.js'
import './common/public.css'



// WEBPACK FOOTER //
// ./src/main.js